import { getStore, setStore, removeStore } from './session'

const sessionId = 'SESSION-ID'
const loginState = 'LOGIN-STATE'
const newPersonFreeOrderCount = 'NEW-PERSON-FREE-ORDER-COUNT'
const goodsDetailData = 'GOODS-DETAIL-DATA'

// 获取session
export function getSessionId () {
  return getStore(sessionId)
}

// 设置session
export function setSessionId (sid) {
  return setStore(sessionId, sid)
}

// 删除session
export function removeSessionId () {
  return removeStore(sessionId)
}

// 获取登录态
export function getLoginState () {
  return getStore(loginState)
}

// 设置登录态
export function setLoginState (state) {
  return setStore(loginState, state)
}

// 删除登录态
export function removeLoginState () {
  return removeStore(loginState)
}

// 设置新人权益订单数
export function setNewPersonFreeOrderCount (state) {
  return setStore(newPersonFreeOrderCount, state)
}

// 获取新人权益订单数
export function getNewPersonFreeOrderCount () {
  return getStore(newPersonFreeOrderCount)
}

// 存储商品详情信息
export function setGoodsDetailData (state) {
  return setStore(goodsDetailData, state)
}

// 获取商品详情信息
export function getGoodsDetailData () {
  return getStore(goodsDetailData)
}
